﻿import {translation} from "@2d-front-monorepo/core";
import {formatCurrency, ReservationResult} from "@2d-front-monorepo/permits-business";
import {PermitTranslations} from "@2d-front-monorepo/shared-translations";
import {JSX} from "react";

export function ReservationTotalComponent({reservation}: { reservation: ReservationResult }): JSX.Element {
	const total = reservation.payment?.quotation?.price.totalWithVat;
	if (total == null || total == 0) {
		return <></>;
	}

	return <footer className="layout horizontal">
		<span className="flex">{translation(PermitTranslations.price)}</span>
		<span className={"tabular-nums"}>{formatCurrency(total)}</span>
	</footer>
}
